module.exports = __webpack_public_path__ + "static/media/logo_light.c112e694.png";